import classNames from "classnames";
import { Typography } from "@circle-react-uikit/Typography";

export interface MobileNotSupportedPanelProps {
  className?: string;
  description: string;
  title: string;
}

export const MobileNotSupportedPanel = ({
  title,
  description,
  className,
}: MobileNotSupportedPanelProps) => (
  <div className={classNames("flex h-full", className)}>
    <div className="mx-auto flex flex-col gap-2 self-center p-6 text-center">
      {title && (
        <div>
          <Typography.TitleSm weight="semibold">{title}</Typography.TitleSm>
        </div>
      )}
      {description && (
        <div>
          <Typography.BodySm color="text-default">
            {description}
          </Typography.BodySm>
        </div>
      )}
    </div>
  </div>
);
